import { SaveBarContext } from "@/context/Savebar";
import useWindowDimensions from "@/hooks/useWindowDimensions";
import React, { useContext, useEffect, useState } from "react";
import Button from "../Buttons/Button";

const renderButtonContent = (isSaveReady: boolean) => {
  return isSaveReady ? (
    <>
      <div className="md:hidden">Changes pending</div>
      <div className="hidden md:block">You have pending changes</div>
    </>
  ) : (
    <>
      <div className="md:hidden">All changes saved</div>
      <div className="hidden md:block">Your changes are up to date</div>
    </>
  );
};

const Savebar = () => {
  const { initSaveBarParams, enableSaveBtn, isGracePeriod, handleSaveClick } =
    useContext(SaveBarContext);

  const [screenWidth, setScreenWidth] = useState(0);
  const [offsetPadding, setOffsetPadding] = useState("0px");
  const { width } = useWindowDimensions();

  const isSaveReady = !isGracePeriod && enableSaveBtn;

  useEffect(() => {
    const sideBarElement = document.getElementById("main-sidebar");

    if (!sideBarElement || typeof ResizeObserver === "undefined") {
      return () => {};
    }

    const updateOffset = () =>
      setOffsetPadding(`${sideBarElement.offsetWidth}px`);
    updateOffset();

    // ResizeObserver fires continuously through the sidebar width transition,
    // so the offset stays in sync during the slide and settles at the final
    // width (a MutationObserver only sampled once at the start of the animation).
    const observer = new ResizeObserver(updateOffset);
    observer.observe(sideBarElement);

    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    const handleResize = () => setScreenWidth(width);

    window.addEventListener("resize", handleResize);
    handleResize();
    return () => window.removeEventListener("resize", handleResize);
  }, [width]);

  if (!initSaveBarParams.renderSaveBar) {
    return null;
  }
  return (
    <>
      <div
        style={{ paddingLeft: screenWidth >= 768 ? offsetPadding : "0px" }}
        className="-translate-x-1/2 pointer-events-none fixed bottom-10 left-1/2 z-10 flex transform items-center justify-center"
      >
        <div
          className={`${
            isSaveReady ? "shadow-dines-green" : ""
          } pointer-events-auto flex w-72 items-center justify-between whitespace-nowrap rounded-2xl bg-dines-purple-darkest px-4 py-3 text-white sm:w-96`}
        >
          <div className="w-[180px]">{renderButtonContent(isSaveReady)}</div>
          <Button
            text="Save"
            onClick={handleSaveClick}
            id="savebar"
            data-test-id="savebar"
            disabled={!isSaveReady}
            margin=""
            buttonType={
              isSaveReady
                ? "bg-dines-green text-dines-purple-darkest"
                : "bg-white bg-opacity-20 text-white text-opacity-30"
            }
            rounding="rounded-md"
            padding="px-6 py-1 pt-1.5"
            fontSize="text-base"
            fontWeight="font-bold"
            extraClasses="tracking-widest uppercase ml-4"
          />
        </div>
      </div>
    </>
  );
};

export default Savebar;
